module.exports = __webpack_public_path__ + "static/ubuntu-2c72ad1840c165c4ceb48398a96c1d85.svg";